// @flow

import React, { Component } from "react";
import { NavHashLink as NavLink } from "react-router-hash-link";
import {
  Accordion,
  AccordionItem,
  AccordionItemState,
  AccordionItemButton,
  AccordionItemHeading,
  AccordionItemPanel
} from "react-accessible-accordion";
import "./AccordionFound.scss";

export default class AccordionFound extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <React.Fragment>
        {this.props.product == "fastGround" ? (
          <Accordion>
            <AccordionItem>
              <AccordionItemHeading
                onClick={event => this.handleClick(event, "4")}
              >
                <AccordionItemButton>
                  <span className="af-icon-plus visible-icon"></span>
                  <span className="af-icon-minus hidden-icon"></span>
                  Miejsca aplikacji
                </AccordionItemButton>
              </AccordionItemHeading>
              <AccordionItemPanel>
                <ul className="benefits-list">
                  <li className="list-item">
                    gruntowanie podłoży mineralnych (beton, cement, ceramika,
                    gips), drewna w tym płyt OSB oraz powierzchni bitumicznych i
                    metalowych
                  </li>
                  <li className="list-item">
                    przygotowanie podłoża pod pokrycia dachowe – bitumiczne
                    (papy samoprzylepne i termozgrzewalne, masy bitumiczne,
                    powłoki dekarskie)
                  </li>
                  <li className="list-item">
                    gruntowanie pod termozgrzewalne i samoprzylepne papy
                    fundamentowe oraz masy hydroizolacyjne
                  </li>
                  <li className="list-item">
                    zabezpieczenie przeciwwilgociowe elementów betonowych i
                    stalowych infrastruktury drogowej, kolejowej itp.
                  </li>
                  <li className="list-item">
                    poprawa szczelności i nośności podłoży niespójnych jak np.
                    remontowane pokrycia bitumiczne
                  </li>
                </ul>
              </AccordionItemPanel>
            </AccordionItem>

            <AccordionItem>
              <AccordionItemHeading
                onClick={event => this.handleClick(event, "4")}
              >
                <AccordionItemButton>
                  <span className="af-icon-plus visible-icon"></span>
                  <span className="af-icon-minus hidden-icon"></span>
                  Sposób aplikacji
                </AccordionItemButton>
              </AccordionItemHeading>
              <AccordionItemPanel>
                <h5 className="small-header">Przygotowanie produktu</h5>
                <p className="acc__para">
                  Produkt gotowy do użytku, ale dopuszczalne jest rozcieńczenie
                  wodą w proporcjach 1:1 do 1:2 (jedna cześć gruntu Evomer do
                  dwóch części wody) dla podłoży chłonnych. Przed użyciem dobrze
                  wymieszać.
                </p>

                <h5 className="small-header">Przygotowanie podłoża</h5>
                <p className="acc__para">
                  Podłoże przed aplikacją należy odpylić, elementy niezwiązane
                  usunąć, zabezpieczyć pęknięcia i ubytki. Powierzchnia powinna
                  być wolna od smarów, tłustych zabrudzeń i rdzy. W tym celu
                  powierzchnie gładkie zaleca się przemyć wodą z detergentem,
                  rozpuszczalnikiem lub zmatowić za pomocą szczotki drucianej.
                  Podłoże nie może być zmrożone, oszronione. Może być wilgotne,
                  ale nie mokre. Musi być pozbawione zastoin wody. Należy usunąć
                  luźne elementy, ostre krawędzie, zanieczyszczenia i pył,
                  części metalowe odrdzewić. W wypadku gruntowania pap
                  nawierzchniowych z posypką mineralną, należy usunąć nadmiar
                  niezwiązanej posypki, a także mchy i porosty oraz inne naloty
                  zmniejszające przyczepność.
                </p>

                <h5 className="small-header">Aplikacja - Gruntowanie</h5>
                <p className="acc__para">
                  Grunt należy nanosić na oczyszczone podłoże za pomocą
                  szczotki, pędzla, wałka lub za pomocą natrysku
                  hydrodynamicznego.
                </p>
                <h5 className="small-header">Powłoka izolacyjna</h5>
                <p className="acc__para">
                  Nałożyć 2 warstwy zwiększając ilość masy do 0,3 kg/m2/każdą
                  warstwę
                </p>
                <p className="acc__para">
                  Aplikacja przy użyciu szczotki, pędzla, wałka lub za pomocą
                  natrysku hydrodynamicznego
                </p>
                <p className="acc__para">
                  Drugą warstwę nanosić po przeschnięciu pierwszej, tak by jej
                  nie uszkodzić
                </p>

                <h5 className="small-header">Powłoka izolacyjna</h5>
                <p className="acc__para">
                  Natrysk hydrodynamiczny (airless) Agregat o wydajności
                  2,3l/min Dysza o otworze 0,019” (0,48mm) Ciśnienie aplikacji
                  150 bar.
                </p>
              </AccordionItemPanel>
            </AccordionItem>

            <AccordionItem>
              <AccordionItemHeading
                onClick={event => this.handleClick(event, "4")}
              >
                <AccordionItemButton>
                  <span className="af-icon-plus visible-icon"></span>
                  <span className="af-icon-minus hidden-icon"></span> Dane
                  techniczne
                </AccordionItemButton>
              </AccordionItemHeading>
              <AccordionItemPanel>
                <div className="table-wrapper">
                  <table>
                    <tbody>
                      <tr>
                        <td>Podłoże</td>
                        <td>Blacha, OSB</td>
                        <td>Beton, ceramika, papa, styropian, XPS</td>
                        <td>
                          Stara papa, renowacja powłok bitumicznych, tynki
                          mineralne i cem.-wapienne
                        </td>
                      </tr>
                      <tr>
                        <td>Rozcieńczenie</td>
                        <td>Nie rozcieńczać</td>
                        <td>1:1</td>
                        <td>1:2</td>
                      </tr>
                      <tr>
                        <td>
                          Zużycie kg/m<sup>2</sup>
                        </td>
                        <td>0,2</td>
                        <td>0,15</td>
                        <td>0,15</td>
                      </tr>
                      <tr>
                        <td>Wydajność z opakowania 18 kg</td>
                        <td>
                          90 m<sup>2</sup>
                        </td>
                        <td>
                          120 m<sup>2</sup>
                        </td>
                        <td>
                          120 m<sup>2</sup>
                        </td>
                      </tr>
                      <tr>
                        <td>Wydajność z opakowania 9 kg</td>
                        <td>
                          45 m<sup>2</sup>
                        </td>
                        <td>
                          60 m<sup>2</sup>
                        </td>
                        <td>
                          60 m<sup>2</sup>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              
              </AccordionItemPanel>
            </AccordionItem>
          </Accordion>
        ) : this.props.product == "fastShell" ? (
          <Accordion>
            <AccordionItem>
              <AccordionItemHeading
                onClick={event => this.handleClick(event, "4")}
              >
                <AccordionItemButton>
                  <span className="af-icon-plus visible-icon"></span>
                  <span className="af-icon-minus hidden-icon"></span>
                  Miejsca aplikacji
                </AccordionItemButton>
              </AccordionItemHeading>
              <AccordionItemPanel>
                <ul className="benefits-list">
                  <li className="list-item">
                    Wykonywanie przeciwwilgociowych hydroizolacji fundamentowych
                  </li>
                </ul>
              </AccordionItemPanel>
            </AccordionItem>

            <AccordionItem>
              <AccordionItemHeading
                onClick={event => this.handleClick(event, "4")}
              >
                <AccordionItemButton>
                  <span className="af-icon-plus visible-icon"></span>
                  <span className="af-icon-minus hidden-icon"></span>
                  Benefity
                </AccordionItemButton>
              </AccordionItemHeading>
              <AccordionItemPanel>
                <ul className="benefits-list">
                  <li className="list-item">
                    szybkoschnąca i odporna na deszcz – już po 2 godzinach
                  </li>
                  <li className="list-item">bezpieczna dla styropianu</li>
                  <li className="list-item">
                    nie zawiera rozpuszczalników – niepalna, bezwonna
                  </li>
                  <li className="list-item">
                    podwyższona odporność na promieniowanie UV do 5 lat
                  </li>
                  <li className="list-item">
                    odporna na temperatury – zachowuje elastyczność w -20oC,
                  </li>
                  <li className="list-item">
                    nie spływa z pionowych powierzchni w temp +90oC
                  </li>
                  <li className="list-item">wysokowydajna</li>
                  <li className="list-item">
                    tworzy powłokę trwale elastyczną pokrywającą pęknięcia i
                    szczeliny
                  </li>
                  <li className="list-item">doskonała przyczepność</li>
                  <li className="list-item">bezpieczna dla środowiska</li>
                </ul>
              </AccordionItemPanel>
            </AccordionItem>

            <AccordionItem>
              <AccordionItemHeading
                onClick={event => this.handleClick(event, "4")}
              >
                <AccordionItemButton>
                  <span className="af-icon-plus visible-icon"></span>
                  <span className="af-icon-minus hidden-icon"></span>Wykonywanie
                  hydroizolacji fundamentowych przeciwwilgociowych
                </AccordionItemButton>
              </AccordionItemHeading>
              <AccordionItemPanel>
                <p className="acc__para">
                  Zagruntuj powierzchnię za pomocą{" "}
                  <span className="bold-text">Szybkiego Gruntu Evomer</span>
                  używając pędzla lub wałka. Po wyschnięciu gruntu (w zależności
                  od warunków pogodowych ok. 20-30 min) nałóż pierwszą warstwę
                  <span className="bold-text">Szybkiej Powłoki Evomer</span> za
                  pomocą wałka lub pędzla. Po wyschnięciu pierwszej warstwy
                  powłoki (ok. 2 – 3 godz. w zależności od warunków pogodowych)
                  wykonaj wyoblenie tzw. fasetę na połączeniu ławy i ściany
                  fundamentowej przy pomocy
                  <span className="bold-text">Masy Szpachlowej Evomer.</span> Po
                  wyschnięciu fasety (w zależności od warunków pogodowych i
                  grubości nałożonej masy ok. 2 -3 godz.) nałóż drugą warstwę{" "}
                  <span className="bold-text">Szybkiej Powłoki Evomer.</span>{" "}
                  Minimalne zużycie masy przy 2 warstwach to 0,7 kg/m². Po
                  wyschnięciu drugiej warstwy powłoki (ok. 2 -3 godz. w
                  zależności od warunków pogodowych) możesz przykleić warstwę
                  izolacji cieplnej. Do tego celu użyj produktu Abizol S, Abizol
                  ST bądź Klej do Styropianu i Płyt XPS.
                </p>
              </AccordionItemPanel>
            </AccordionItem>
            <AccordionItem>
              <AccordionItemHeading
                onClick={event => this.handleClick(event, "4")}
              >
                <AccordionItemButton>
                  <span className="af-icon-plus visible-icon"></span>
                  <span className="af-icon-minus hidden-icon"></span>Dane
                  techniczne
                </AccordionItemButton>
              </AccordionItemHeading>
              <AccordionItemPanel>
                <p className="acc__para">
                  Powłokę należy nanosić na oczyszczone podłoże za pomocą
                  szczotki, pędzla, wałka lub za pomocą natrysku
                  hydrodynamicznego.
                </p>
                <ul className="benefits-list">
                  <p className="list-header">
                    Parametry natrysku hydrodynamicznego:
                  </p>
                  <li className="list-item">
                    Natrysk hydrodynamiczny (airless)
                  </li>
                  <li className="list-item">
                    Agregat o wydajności 2,3l/min, (przy większych pracach
                    zalecane powyżej 4l/min)
                  </li>
                  <li className="list-item">Dysza o otworze 0,019” (0,48mm)</li>
                  <li className="list-item">
                    Ciśnienie aplikacji 180-190 bar.
                  </li>
                </ul>
                <div className="table-wrapper">
                  <table>
                    <tbody>
                      <tr>
                        <td>Konsystencja</td>
                        <td>
                          Masa o konsystencji gęsto-płynnej, jednorodna, bez
                          wtrąceń
                        </td>
                      </tr>
                      <tr>
                        <td>Zużycie</td>
                        <td>Średnio 0,35 kg / 1m2 /na warstwę</td>
                      </tr>
                      <tr>
                        <td>Czas schnięcia w temp +20C/50%rh [min]</td>
                        <td>2 godz.</td>
                      </tr>
                    </tbody>
                  </table>
                  <p className="acc__para">
                    Powłokę należy nanosić na oczyszczone podłoże za pomocą
                    szczotki, pędzla, wałka lub za pomocą natrysku
                    hydrodynamicznego.
                  </p>
                </div>
              </AccordionItemPanel>
            </AccordionItem>
          </Accordion>
        ) : this.props.product == "fastFill" ? (
          <Accordion>
            <AccordionItem>
              <AccordionItemHeading
                onClick={event => this.handleClick(event, "4")}
              >
                <AccordionItemButton>
                  <span className="af-icon-plus visible-icon"></span>
                  <span className="af-icon-minus hidden-icon"></span>
                  Benefity
                </AccordionItemButton>
              </AccordionItemHeading>
              <AccordionItemPanel>
                <ul className="benefits-list">
                  <li className="list-item">
                    szybkoschnąca i odporna na deszcz – już po 2 godzinach
                  </li>
                  <li className="list-item">bezpieczna dla styropianu</li>
                  <li className="list-item">
                    nie zawiera rozpuszczalników – niepalna, bezwonna
                  </li>
                  <li className="list-item">
                    podwyższona odporność na promieniowanie UV do 5 lat
                  </li>
                  <li className="list-item">
                    odporna na temperatury – zachowuje elastyczność w -20oC, nie
                    spływa z pionowych powierzchni w temp +90oC
                  </li>
                  <li className="list-item">
                    tworzy trwale elastyczne wypełnienie mostkujące rysy do 2 mm
                  </li>
                </ul>
              </AccordionItemPanel>
            </AccordionItem>

            <AccordionItem>
              <AccordionItemHeading
                onClick={event => this.handleClick(event, "4")}
              >
                <AccordionItemButton>
                  <span className="af-icon-plus visible-icon"></span>
                  <span className="af-icon-minus hidden-icon"></span>
                  Sposób aplikacji - szpachlowanie i klejenie
                </AccordionItemButton>
              </AccordionItemHeading>
              <AccordionItemPanel>
                <ul className="benefits-list">
                  <p className="list-bold__header">Przygotowanie produktu</p>
                  <li className="list-item">Produkt jest gotowy do użycia.</li>
                </ul>
                <ul className="benefits-list">
                  <p className="list-bold__header">Przygotowanie produktu</p>
                  <li className="list-item">
                    Podłoże powinno być wysezonowane czyste, suche lub lekko
                    wilgotne i oczyszczone z tłuszczu i innych czynników
                    zmniejszających przyczepność. Podłoża porowate i pylące
                    zagruntować Szybkim Gruntem Polimerowo-Bitumicznym EVOMER.
                  </li>
                </ul>
                <ul className="benefits-list">
                  <p className="list-bold__header">Aplikacja</p>
                  <li className="list-item">
                    Evomer Masę Szpachlową nakłada się za pomocą szpachli lub
                    pacy.
                  </li>
                </ul>
                <ul className="benefits-list">
                  <p className="list-bold__header">Szpachlowanie</p>
                  <li className="list-item">
                    Nanosić warstwami o grubości do 10mm.
                  </li>
                  <li className="list-item">
                    Przy wysokich temperaturach i silnym nasłonecznieniu nanosić
                    cieńsze warstwy.
                  </li>
                  <li className="list-item">
                    Jeśli szpachlowanie przebiega na połączeniu dwóch materiałów
                    miejsce należy wzmocnić pasem zatopionej włókniny
                    poliestrowej o gramaturze: ok. 80 g/m2 z wywinięciem po 15cm
                    na każdą stronę.
                  </li>
                  <li className="list-item">
                    Miejsca szpachlowane można pokrywać papą lub masą powłokową
                    Evomer po wyschnięciu.
                  </li>
                  <li className="list-item">
                    Zużycie ok.: 1,2 kg na m2 przy grubości 1mm. Realne zużycie
                    zależne jest od rodzaju prac.
                  </li>
                  <li className="list-item">
                    Czas schnięcia: wstępnie 2 godziny, pełne zależy od grubości
                    wypełnienia – około 2 mm na dobę w temp 20o C
                  </li>
                </ul>
                <ul className="benefits-list">
                  <p className="list-bold__header">Klejenie</p>
                  <li className="list-item">
                    Przyklejanie materiałów izolacyjnych i termoizolacyjnych do
                    podłoży z blachy, betonu, papy, izolacji wykonanych z mas
                    bitumicznych.
                  </li>
                  <li className="list-item">
                    Na montażowe strony płyt ocieplających nałożyć punktowo lub
                    pasami Masę Szpachlową EVOMER.
                  </li>
                  <li className="list-item">
                    Odczekać około 10 minut i docisnąć do powierzchni.
                  </li>
                  <li className="list-item">
                    Płyty ocieplające hydrofobizowane przed klejeniem należy
                    przeszlifować.
                  </li>
                  <li className="list-item">
                    Niewłaściwe jest klejenie dużych powierzchni dwóch
                    materiałów niechłonnych np. papa z rolki do blachy lub papy
                    podkładowej.
                  </li>
                </ul>
              </AccordionItemPanel>
            </AccordionItem>

            <AccordionItem>
              <AccordionItemHeading
                onClick={event => this.handleClick(event, "4")}
              >
                <AccordionItemButton>
                  <span className="af-icon-plus visible-icon"></span>
                  <span className="af-icon-minus hidden-icon"></span> Dane
                  techniczne
                </AccordionItemButton>
              </AccordionItemHeading>
              <AccordionItemPanel>
                <div className="table-wrapper">
                  <table>
                    <tbody>
                      <tr>
                        <td>Konsystencja</td>
                        <td>
                          Masa o konsystencji gęstej, kleistej, jednorodna, z
                          mikrowłóknami
                        </td>
                      </tr>
                      <tr>
                        <td>Gęstość</td>
                        <td>1,15 – 1,25</td>
                      </tr>
                      <tr>
                        <td>Zużycie</td>
                        <td>1,2 kg na m2 przy grubości 1mm</td>
                      </tr>
                      <tr>
                        <td>Temperatura aplikacji [°C ]</td>
                        <td>1,2 kg na m2 przy grubości 1mm</td>
                      </tr>
                      <tr>
                        <td>Odporność na deszcz</td>
                        <td>Po 2 godz.</td>
                      </tr>
                      <tr>
                        <td>Czas schnięcia w temp +5C/50%rh</td>
                        <td>2mm/ 24godz.</td>
                      </tr>
                      <tr>
                        <td>Temperatura aplikacji [°C ]</td>
                        <td>+5 +35</td>
                      </tr>
                      <tr>
                        <td>Elastyczność w niskich temperaturach</td>
                        <td>-20oC</td>
                      </tr>
                      <tr>
                        <td>
                          Odporność na wysoką temperaturę (nie spływa z
                          powierzchni pionowych)
                        </td>
                        <td>90oC</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </AccordionItemPanel>
            </AccordionItem>
          </Accordion>
        ) : this.props.product == "abizolST" ? (
          <Accordion>
            <AccordionItem>
              <AccordionItemHeading
                onClick={event => this.handleClick(event, "4")}
              >
                <AccordionItemButton>
                  <span className="af-icon-plus visible-icon"></span>
                  <span className="af-icon-minus hidden-icon"></span>
                  Opis
                </AccordionItemButton>
              </AccordionItemHeading>
              <AccordionItemPanel>
              <p className="acc__para">Dyspersyjny lepik asfaltowy, wysoko modyfikowany kauczukiem syntetycznym. Przeznaczony do klejenia płyt styropianowych do zagruntowanych podłoży na fundamentach oraz do wykonywania hydroizolacji lekkich, średnich i ciężkich podziemnych części budowli. Tworzy zwarte i wyjątkowo elastoplastyczne powłoki.</p>
              </AccordionItemPanel>
            </AccordionItem>

            <AccordionItem>
              <AccordionItemHeading
                onClick={event => this.handleClick(event, "4")}
              >
                <AccordionItemButton>
                  <span className="af-icon-plus visible-icon"></span>
                  <span className="af-icon-minus hidden-icon"></span>
                  Benefity
                </AccordionItemButton>
              </AccordionItemHeading>
              <AccordionItemPanel>
                <ul className="benefits-list">
                  <li className="list-item">niweluje pęknięcia do 5 mm</li>
                  <li className="list-item">nie spływa z pionowych powierzchni</li>
                  <li className="list-item">bez rozpuszczalników</li>
                  <li className="list-item">przydatny do użycia 12 miesięcy od daty produkcji</li>
                </ul>
              </AccordionItemPanel>
            </AccordionItem>

            <AccordionItem>
              <AccordionItemHeading
                onClick={event => this.handleClick(event, "4")}
              >
                <AccordionItemButton>
                  <span className="af-icon-plus visible-icon"></span>
                  <span className="af-icon-minus hidden-icon"></span>
                  Zastosowanie
                </AccordionItemButton>
              </AccordionItemHeading>
              <AccordionItemPanel>
                  <ul className="benefits-list">
                    <li className="list-item">przyklejanie płyt styropianowych i ekstrudowanych</li>
                    <li className="list-item">hydroizolacje części podziemnych budowli - lekkich, średnich i ciężkich przeciwwodnych</li>
                    <li className="list-item">hydroizolacje podposadzkowe piwnic, garaży, tarasów</li>
                    <li className="list-item">nie stosować w kontakcie ze smołą i do pap smołowych</li>
                  </ul>
              </AccordionItemPanel>
            </AccordionItem>
            <AccordionItem>
              <AccordionItemHeading
                onClick={event => this.handleClick(event, "4")}
              >
                <AccordionItemButton>
                  <span className="af-icon-plus visible-icon"></span>
                  <span className="af-icon-minus hidden-icon"></span>
                  Dane techniczne
                </AccordionItemButton>
              </AccordionItemHeading>
              <AccordionItemPanel>
                  <ul className="benefits-list">
                    <li className="list-item">Wydajność - klejenie ok. 1 kg/m²</li>
                  </ul>
              </AccordionItemPanel>
            </AccordionItem>
          </Accordion>
        
        ) : this.props.product == "xps" ? (
          <Accordion>
            <AccordionItem>
              <AccordionItemHeading
                onClick={event => this.handleClick(event, "4")}
              >
                <AccordionItemButton>
                  <span className="af-icon-plus visible-icon"></span>
                  <span className="af-icon-minus hidden-icon"></span>
                  Opis
                </AccordionItemButton>
              </AccordionItemHeading>
              <AccordionItemPanel>
              <p className="acc__para">Profesjonalny jednokomponentowy klej poliuretanowy przeznaczony do klejenia płyt styrodurowych XPS do membran bitumicznych przy termoizolacji fundamentów. Klej jest bardzo wygodny w nakładaniu, a dzięki jego użyciu, montaż płyt z polistyrenu ekstrudowanego XPS jest dużo łatwiejszy. Zastosowanie kleju znacznie przyspiesza wykonywanie prac: pełne utwardzenie uzyskuje już po 24 h. Klej poliuretanowy do płyt z polistyrenu ekstrudowanego XPS i styropianu wykazuje doskonałą przyczepność do typowych materiałów konstrukcyjnych, takich jak: mury z cegły, pustaki, beton, tynki, a także drewno, szkło, metale, styropian, twarde PVC i sztywne piany PUR, a zwłaszcza membrany bitumiczne, papy i dyspersyjne masy asfaltowo-kauczukowe.</p>
              </AccordionItemPanel>
            </AccordionItem>

            <AccordionItem>
              <AccordionItemHeading
                onClick={event => this.handleClick(event, "4")}
              >
                <AccordionItemButton>
                  <span className="af-icon-plus visible-icon"></span>
                  <span className="af-icon-minus hidden-icon"></span>
                  Benefity
                </AccordionItemButton>
              </AccordionItemHeading>
              <AccordionItemPanel>
                <ul className="benefits-list">
                  <li className="list-item">łatwy i wygodny w nakładaniu</li>
                  <li className="list-item">wstępne utwardzenie już po 2 h</li>
                  <li className="list-item">zastosowanie w szerokim zakresie temperatur</li>
                  <li className="list-item">doskonała przyczepność do dyspersyjnych mas asfaltowokauczukowych</li>
                </ul>
              </AccordionItemPanel>
            </AccordionItem>

            <AccordionItem>
              <AccordionItemHeading
                onClick={event => this.handleClick(event, "4")}
              >
                <AccordionItemButton>
                  <span className="af-icon-plus visible-icon"></span>
                  <span className="af-icon-minus hidden-icon"></span>
                  Zastosowanie
                </AccordionItemButton>
              </AccordionItemHeading>
              <AccordionItemPanel>
              <p className="acc__para">klejenie płyt styropianowych oraz płyt polistyrenowych XPS do fundamentów i przyziemnych części budynków, ścian piwnic, cokołów, attyk, fragmentów elewacji szczególnie narażonych na uszkodzenia mechaniczne, tj. naroża budynków, strefy wejść i klatek schodowych do budynków użyteczności publicznej: urzędów, przychodni, szpitali, przedszkoli, szkół itp.</p>
              </AccordionItemPanel>
            </AccordionItem>
            <AccordionItem>
              <AccordionItemHeading
                onClick={event => this.handleClick(event, "4")}
              >
                <AccordionItemButton>
                  <span className="af-icon-plus visible-icon"></span>
                  <span className="af-icon-minus hidden-icon"></span>
                  Dane techniczne
                </AccordionItemButton>
              </AccordionItemHeading>
              <AccordionItemPanel>
                  <ul className="benefits-list">
                    <li className="list-item">temperatura pracy (podłoża i powietrza): od 0°C do +30°C</li>
                    <li className="list-item">temperatura puszki: od +10°C do +30°C</li>
                    <li className="list-item">czas korekty: ok. 5 – 15 min.</li>
                    <li className="list-item">czas pełnego utwardzenia: już po 24 h</li>
                    <li className="list-item">współczynnik przewodzenia ciepła: 0,036 W/mK</li>
                    <li className="list-item">wydajność: ok. 14 m²</li>
                    <li className="list-item">Zawartość VOC (lotnych związków organicznych): 138 [g/puszka].</li>
                  </ul>
              </AccordionItemPanel>
            </AccordionItem>
          </Accordion>
        
        ) : this.props.product == "abizolw2k" ? (
          <Accordion>
            <AccordionItem>
              <AccordionItemHeading
                onClick={event => this.handleClick(event, "4")}
              >
                <AccordionItemButton>
                  <span className="af-icon-plus visible-icon"></span>
                  <span className="af-icon-minus hidden-icon"></span>
                  Opis
                </AccordionItemButton>
              </AccordionItemHeading>
              <AccordionItemPanel>
                <p className="acc__para">Abizol W 2K masa bitumiczno-polimerowa typu KMB służy do wykonywana grubowarstowych powłok hydroizolacyjnych (typu lekkiego, średniego i ciężkiego lub wg DIN 18 195 części 4, 5, 6) na podłożach mineralnych poniżej poziomu gruntu. </p>
                <p className="acc__para">W szczególności do hydroizolacji fundamentów, płyt fundamentowych i ścian piwnic od strony napierania wody. Do uszczelnień między warstwowych (pod jastrychem dociskowym) w pomieszczeniach mokrych, na balkonach i tarasach. Może być także używana do przyklejania płyt termoizolacyjnych do ścian fundamentów. </p>
              </AccordionItemPanel>
            </AccordionItem>

            <AccordionItem>
              <AccordionItemHeading
                onClick={event => this.handleClick(event, "4")}
              >
                <AccordionItemButton>
                  <span className="af-icon-plus visible-icon"></span>
                  <span className="af-icon-minus hidden-icon"></span>
                  Benefity
                </AccordionItemButton>
              </AccordionItemHeading>
              <AccordionItemPanel>
                <ul className="benefits-list">
                  <li className="list-item">Szybko wiąże przez chemiczną reakcję 2-składników</li>
                  <li className="list-item">Odporna na deszcz po 3 godzinach</li>
                  <li className="list-item">Zasypywanie po 2-3 dniach</li>
                  <li className="list-item">Łatwa aplikacja pacą</li>
                  <li className="list-item">Możliwa aplikacja natryskowa Możliwa do nanoszenia grubowarstwowo do 5 mm w 1 warstwie</li>
                  <li className="list-item">Nie spływa z pionowych powierzchni</li>
                  <li className="list-item">Ekologiczna – nie zawiera rozpuszczalników organicznych</li>
                  <li className="list-item">Wzmacniana włóknami</li>
                  <li className="list-item">Elastyczna, mostkuje rysy do 2 mm (klasa CB2)</li>
                  <li className="list-item">Wodoszczelna do cieśnienia 0,75 MPa (klasa W2A)</li>
                  <li className="list-item">Wytrzymała na ściskanie (klasa C2A)</li>
                  <li className="list-item">Spełnia wymagania normy DIN 18 195 części 4, 5, 6.</li>
                  <li className="list-item">Odporna na starzenie, działanie wody i substancje agresywne naturalnie występujące w gruncie</li>
                  <li className="list-item">Przydatny do użycia 9 miesięcy od daty produkcji</li>
                </ul>
              </AccordionItemPanel>
            </AccordionItem>

            <AccordionItem>
              <AccordionItemHeading
                onClick={event => this.handleClick(event, "4")}
              >
                <AccordionItemButton>
                  <span className="af-icon-plus visible-icon"></span>
                  <span className="af-icon-minus hidden-icon"></span>
                  Zastosowanie
                </AccordionItemButton>
              </AccordionItemHeading>
              <AccordionItemPanel>
                  <ul className="benefits-list">
                    <li className="list-item">Hydroizolacja fundamentów, płyt fundamentowych, ścian piwnic od strony napierania wody</li>
                    <li className="list-item">Uszczelnienia między warstwowe (pod jastrychem dociskowym) w pomieszczeniach mokrych, na balkonach i tarasach</li>
                    <li className="list-item">Przyklejanie płyt termoizolacyjnych do ścian fundamentów</li>
                  </ul>
              </AccordionItemPanel>
            </AccordionItem>
            <AccordionItem>
              <AccordionItemHeading
                onClick={event => this.handleClick(event, "4")}
              >
                <AccordionItemButton>
                  <span className="af-icon-plus visible-icon"></span>
                  <span className="af-icon-minus hidden-icon"></span>
                  Dane techniczne
                </AccordionItemButton>
              </AccordionItemHeading>
              <AccordionItemPanel>
              <div className="table-wrapper">
                  <table>
                    <tbody>
                      <tr>
                        <td>Typ izolacji</td>
                        <td>Liczba warstw</td>
                        <td>Końcowa grubość powłoki [mm]</td>
                        <td>Orientacyjne zużycie [kg]
                        </td>
                      </tr>
                      <tr>
                        <td>Lekka – wilgoć gruntowa</td>
                        <td>2</td>
                        <td>3</td>
                        <td>4,5</td>
                      </tr>
                      <tr>
                        <td>
                        Średnia - woda nienapierająca 
                        </td>
                        <td>2</td>
                        <td>3</td>
                        <td>4,5</td>
                      </tr>
                      <tr>
                        <td>Ciężka - napierająca woda gruntowa </td>
                        <td>
                        2 z wkładką
                        </td>
                        <td>
                          4
                        </td>
                        <td>
                          5,5
                        </td>
                      </tr>
                      <tr>
                        <td>Klejenie płyt </td>
                        <td>
                        </td>
                        <td>
                          -
                        </td>
                        <td>
                          1 -2
                        </td>
                      </tr>
                      <tr>
                        <td colSpan="4">*Nierówna powierzchnia może zwiększyć zużycie.</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              
              </AccordionItemPanel>
            </AccordionItem>
          </Accordion>
        
        ) : (
          <React.Fragment></React.Fragment>
        )}
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/AccordionFound/AccordionFound.js